import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { Text } from '~/shared/components/Text';

export default function DeliveryMethod({ method }: { method: ShopTypes.DeliveryMethod }) {
    const { translate } = useTranslations();

    const getStatusTranslation = () => {
        switch (method) {
            case ShopTypes.DeliveryMethod.Pickup:
                return translate('mit-fog.deliveryMethod.pickup');
            case ShopTypes.DeliveryMethod.Delivery:
                return translate('mit-fog.deliveryMethod.delivery');
            case ShopTypes.DeliveryMethod.PickUpDirect:
                return translate('mit-fog.deliveryMethod.pickupDirect');
            case ShopTypes.DeliveryMethod.Courier:
                return translate('mit-fog.deliveryMethod.courier');
            case ShopTypes.DeliveryMethod.Mover:
                return translate('mit-fog.deliveryMethod.mover');
            case ShopTypes.DeliveryMethod.DeliveryDirect:
                return translate('mit-fog.deliveryMethod.deliveryDirect');
            case ShopTypes.DeliveryMethod.Postal:
                return translate('mit-fog.deliveryMethod.postal');
            case ShopTypes.DeliveryMethod.PostalBusiness:
                return translate('mit-fog.deliveryMethod.postalBusiness');
        }
    };

    return <Text>{getStatusTranslation()}</Text>;
}
